import React from 'react';
import './BlogSectionblog.css';
import Header from '../../Header';
import Navbar from '../../Navbar';
import Footers from '../../Footers';
import NewsletterSection from '../../NewsletterSection';
import image1 from '../../services/services-images/blog1.webp';
import image2 from '../../services/services-images/blog2.webp';
import image3 from '../../services/services-images/blog3.webp';
import image4 from '../../services/services-images/blog4.jpg';
import image5 from '../../services/services-images/blog5.jpg';
import image6 from '../../services/services-images/blog6.jpg';

import Blogimages from '../services-images/blog-image.webp';




const blogs = [
    {
      id: 1,
      date: '03 Jan',
      image: image1,
      title: 'Shilajit vs. Winter Fatigue: How to Stay Energetic During the Chilly Season',
      desc: 'Winter is here, and while the cold weather brings cozy moments and steaming cups of tea...'
    },
    {
      id: 2,
      date: '26 Nov',
      image: image2,
      title: 'Naturally Nourish Skin & Hair This Winter',
      desc: 'The dry breeze & the chilly weather can really dry things out, leaving our skin...'
    },
    {
      id: 3,
      date: '15 Dec',
      image: image3,
      title: 'Benefits Of Shilajit and Ashwagandha',
      desc: 'Boosts Energy and Stamina: Enhances physical performance and reduces fatigue.'
    },
    {
        id: 4,
        date: '15 Dec',
        image: image4,
        title: 'Ten Healthy Post Workout Meals',
        desc: 'Boosts Energy and Stamina: Enhances physical performance and reduces fatigue.'
      },
      {
        id: 5,
        date: '15 Dec',
        image: image5,
        title: 'Top 10 Healthy Weight Loss Foods',
        desc: 'Boosts Energy and Stamina: Enhances physical performance and reduces fatigue.'
      },
      {
        id: 6,
        date: '15 Dec',
        image: image6,
        title: 'How to Heal Thyroid With The Power Of Ayurveda',
        desc: 'Boosts Energy and Stamina: Enhances physical performance and reduces fatigue.'
      },
  ];

export default function BlogSection() {
    return (
        <div>
            <Header />
            <Navbar />
                  <img src={Blogimages} alt="icons" className="Banner-blog" />

            <div className='blog-text'>
                <h1 className='text-blog'>Blogs</h1>
            </div>
            <div className="blog-section-blog-page">
                {blogs.map((blog) => (
                    <div className="blog-card-blog-page" key={blog.id}>
                        <div className="blog-image-blog-page">
                            <img src={blog.image} alt={blog.title} />
                            <div className="blog-date-blog-page">
                                {blog.date}
                            </div>
                        </div>
                        <h3 className="blog-title-blog-page">{blog.title}</h3>
                        <p className="blog-desc-blog-page">{blog.desc}</p>
                    </div>
                ))}

            </div>
            <NewsletterSection />
            <Footers />
        </div>
    );
}
